__turbopack_context__.v({
  "banner": "FvRTPa_banner",
  "colorDanger": "FvRTPa_colorDanger",
  "colorInformative": "FvRTPa_colorInformative",
  "colorNeutral": "FvRTPa_colorNeutral",
  "colorSuccess": "FvRTPa_colorSuccess",
  "colorWarning": "FvRTPa_colorWarning",
  "content": "FvRTPa_content",
  "contentCentered": "FvRTPa_contentCentered",
  "icon": "FvRTPa_icon",
  "overlay": "FvRTPa_overlay",
});
